
import { LOCATION_INITIALIZED, APP_BASE_HREF } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsModule } from '@ngxs/store';
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { ContentShellModule } from './content-shell/content-shell.module';
import { CoreModule } from './core/core.module';
import { FooterShellModule } from './footer-shell/footer-shell.module';
import { HeaderShellModule } from './header-shell/header-shell.module';
import { SharedModule } from './shared/shared.module';

export const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + environment.cb);

export const translationProviderFactory = (translate: TranslateService, injector: Injector) =>
  () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      let langToSet = 'en';
      if (environment.splunkSourceEnv || environment.splunkSourceEnv.toLowerCase().indexOf('prod') > -1) {
        langToSet = environment.appCountryCode.toLowerCase();
      }
      translate.setDefaultLang(langToSet);
      translate.use(langToSet).subscribe(() => {
        // Successfully initialized '${langToSet}' language.
      }, err => {
        // Problem with '${langToSet}' language initialization.
      }, () => {
        resolve(null);
      });
    });
  });

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxsModule.forRoot(),
    HeaderShellModule,
    ContentShellModule.forRoot(appConfig.contentShellConfig),
    FooterShellModule,
    CoreModule,
    SharedModule.forRoot(appConfig.sharedConfig, appConfig.owlCarouselConfig)
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/mylist/' },
    Title,
    { provide: APP_INITIALIZER, useFactory: translationProviderFactory, deps: [TranslateService, Injector], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
